// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","danger":"Button_danger__U+J2L","transparent":"Button_transparent__puDsp"};